import { Component, forwardRef, inject, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '../abstract-form-control';
import { LabelItemDto, LabelService, SortDto } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import OrderEnum = SortDto.OrderEnum;

@Component({
  standalone: false,
  selector: 'wr-label-select',
  templateUrl: './label-select.component.html',
  styleUrls: ['./label-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LabelSelectComponent),
      multi: true,
    },
  ],
})
export class LabelSelectComponent extends AbstractFormControl<LabelItemDto> {
  readonly labelService = inject(LabelService);

  @Input()
  showEmptyOption = false;

  labels = asyncComputed(() => this.labelService.findAll({
    sort: {
      sort: 'name',
      order: OrderEnum.Asc,
    },
  }), undefined);

  compareByFn = (a: LabelItemDto | undefined, b: LabelItemDto | undefined) => a?.id === b?.id;
}
